import Timeline from './Timeline';
export default Timeline;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/timeline/index.js
// module id = 851
// module chunks = 3